(() => {
  const container = document.getElementById("hrc-cart-items-section");
  if (!container) return;

  const CART_CHANGE_URL = "/cart/change.js";
  const CART_CLEAR_URL = "/cart/clear.js";

  const setDisabled = (rowEl, disabled) => {
    rowEl
      ?.querySelectorAll(
        ".hrc-quantity-btn, .hrc-quantity-input, .hrc-remove-item",
      )
      .forEach((el) => {
        el.disabled = !!disabled;
        if (disabled) el.setAttribute("aria-busy", "true");
        else el.removeAttribute("aria-busy");
      });
  };

  const postCartChange = async ({ key, quantity }) => {
    const res = await fetch(CART_CHANGE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity }),
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(text || `Cart change failed (${res.status})`);
    }

    return await res.json();
  };

  const clearCart = async () => {
    const res = await fetch(CART_CLEAR_URL, {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(text || `Cart clear failed (${res.status})`);
    }
  };

  const clampQty = (n, max = Infinity) => {
    const num = Number.isFinite(n) ? n : parseInt(String(n), 10);
    if (!Number.isFinite(num)) return 0;
    const capped = Math.max(0, Math.floor(num));
    if (!Number.isFinite(max)) return capped;
    return Math.min(max, capped);
  };

  const getRowMax = (rowEl, input) => {
    const raw = input?.dataset?.max ?? input?.getAttribute("max");
    const max = parseInt(raw || "", 10);
    return Number.isFinite(max) && max > 0 ? max : Infinity;
  };

  const syncRowQtyButtons = (rowEl, input, qty) => {
    const max = getRowMax(rowEl, input);
    const minus = rowEl?.querySelector(".hrc-quantity-btn.minus");
    const plus = rowEl?.querySelector(".hrc-quantity-btn.plus");
    if (minus) minus.disabled = qty <= 0;
    if (plus) plus.disabled = Number.isFinite(max) && qty >= max;
  };

  const updateRowQuantity = async (rowEl, nextQty) => {
    if (rowEl?.classList.contains("hrc-cart-item--campaign-gift")) return;
    const key = rowEl?.dataset?.key;
    if (!key) return;

    setDisabled(rowEl, true);
    try {
      await postCartChange({ key, quantity: nextQty });
      window.location.reload();
    } catch (e) {
      console.error(e);
      setDisabled(rowEl, false);
    }
  };

  container.addEventListener("click", (e) => {
    const removeBtn = e.target.closest(".hrc-remove-item");
    if (removeBtn && container.contains(removeBtn) && !removeBtn.disabled) {
      e.preventDefault();
      const rowEl = removeBtn.closest(".hrc-cart-item");
      if (rowEl?.classList.contains("hrc-cart-item--campaign-gift")) return;
      if (rowEl) updateRowQuantity(rowEl, 0);
      return;
    }

    const btn = e.target.closest(".hrc-quantity-btn");
    if (!btn || !container.contains(btn)) return;

    const rowEl = btn.closest(".hrc-cart-item");
    const input = rowEl?.querySelector(".hrc-quantity-input");
    if (!rowEl || !input || btn.disabled) return;
    if (rowEl.classList.contains("hrc-cart-item--campaign-gift")) return;

    e.preventDefault();

    const max = getRowMax(rowEl, input);
    const current = clampQty(input.value, max);
    const delta = btn.classList.contains("plus")
      ? 1
      : btn.classList.contains("minus")
        ? -1
        : 0;
    const next = clampQty(current + delta, max);

    if (next === current) return;
    input.value = String(next);
    syncRowQtyButtons(rowEl, input, next);
    updateRowQuantity(rowEl, next);
  });

  let debounceTimer = null;
  const scheduleInputCommit = (rowEl, inputEl) => {
    const max = getRowMax(rowEl, inputEl);
    const next = clampQty(inputEl.value, max);
    inputEl.value = String(next);
    syncRowQtyButtons(rowEl, inputEl, next);
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => updateRowQuantity(rowEl, next), 300);
  };

  container.addEventListener("input", (e) => {
    const input = e.target.closest(".hrc-quantity-input");
    if (!input || !container.contains(input)) return;
    const rowEl = input.closest(".hrc-cart-item");
    if (!rowEl) return;
    scheduleInputCommit(rowEl, input);
  });

  container.addEventListener("keydown", (e) => {
    const input = e.target.closest(".hrc-quantity-input");
    if (!input || !container.contains(input)) return;
    if (e.key !== "Enter") return;

    const rowEl = input.closest(".hrc-cart-item");
    if (!rowEl) return;
    e.preventDefault();
    updateRowQuantity(rowEl, clampQty(input.value, getRowMax(rowEl, input)));
  });

  container.addEventListener("click", async (e) => {
    const clearBtn = e.target.closest("[data-clear-cart]");
    if (!clearBtn || !container.contains(clearBtn)) return;

    e.preventDefault();
    const confirmed = window.confirm(
      (window.hrcI18n?.clearCartConfirm || "All items in your cart will be removed. Do you want to continue?"),
    );
    if (!confirmed) return;

    clearBtn.disabled = true;
    try {
      await clearCart();
      window.location.reload();
    } catch (err) {
      console.error(err);
      clearBtn.disabled = false;
    }
  });
})();
